import { __awaiter } from "tslib";
import { get } from 'svelte/store';
import { Backend } from './backend';
import { AppState } from '../etc/stores';
import { Container, Service } from './container';
import Analytics from './analytics';
export class FreeCoinsCampaign extends Service {
    constructor() {
        super(...arguments);
        this.backend = this.ctx.get(Backend);
        this.mappedErrorsToNotifications = {
            'exceptions.free-coins.alreadyGet': 'welcomeCoinPreviouslyClaimed',
            'exceptions.free-coins.onlyNewCustomer': 'welcomeCoinToNewCustomers',
            'exceptions.free-coins.campaignExpired': 'welcomeCoinExpired'
        };
    }
    loadState() {
        return __awaiter(this, void 0, void 0, function* () {
            const campaignData = yield this.getAvailableCampaign();
            const status = yield this.getStatusCampaign(campaignData === null || campaignData === void 0 ? void 0 : campaignData.id);
            AppState.update(state => (Object.assign(Object.assign({}, state), { freeCoinsCampaign: Object.assign({ coupon: state.freeCoinsCampaign.coupon, alreadyRedeemed: status.alreadyRedeemed }, campaignData) })));
        });
    }
    claimCampaignCoupon(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { oauthId } = get(AppState).business;
            let { id } = get(AppState).freeCoinsCampaign;
            const analyticsCategory = params.analyticsCategory;
            delete params.analyticsCategory;
            if (!id) {
                id = (yield this.getAvailableCampaign()).id;
            }
            const coupon = yield this.backend.claimFreeCoinsCampaign(id, Object.assign({ oauthId }, params));
            if (analyticsCategory) {
                Analytics.logEvent(`claim-welcome-coins`, analyticsCategory);
            }
            AppState.update(state => (Object.assign(Object.assign({}, state), { freeCoinsCampaign: {
                    coupon,
                    alreadyRedeemed: true
                } })));
        });
    }
    getNotificationByErrorSlug(slug) {
        return (this.mappedErrorsToNotifications[slug] || 'paymentCoinUnexpectedError');
    }
    getAvailableCampaign() {
        return __awaiter(this, void 0, void 0, function* () {
            const businessId = get(AppState).business.id;
            if (yield this.backend.isSoftLogin())
                return;
            return this.backend.getFreeCoinsAvailableCampaign(businessId);
        });
    }
    getStatusCampaign(freeCoinsCampaignId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const accessToken = get(AppState).auth.access_token;
                if (freeCoinsCampaignId && accessToken) {
                    return this.backend.getFreeCoinsStatusCampaign(freeCoinsCampaignId);
                }
                else {
                    return {};
                }
            }
            catch (_a) {
                return {};
            }
        });
    }
}
Container.add(FreeCoinsCampaign);
